import { TService } from './../lib/types'
import React from 'react'

import { ProductServices_Info } from '@/features/product-services/ui/ProductServices_Info/ProductServices_Info'
import { ProductServices_List } from '@/features/product-services/ui/ProductServices_List/ProductServices_List'

import cl from './ProductServices.module.scss'

enum ViewType {
	Info = `info`,
	List = `list`
}

export type ProductServicesProps = {
	viewType?: `${ViewType}`
	services: TService[]
	relatedId: number
	isCart?: boolean
	activeServices?: string[]
	onClick?: () => void
}

export const ProductServices = ({
	viewType = `info`,
	services,
	relatedId,
	isCart,
	activeServices,
	onClick
}: ProductServicesProps): JSX.Element => (
	<section className={cl.root} aria-label="Выбор услуг для устройства">
		{(() => {
			switch (viewType) {
				case ViewType.Info:
					return <ProductServices_Info isCart={isCart} services={services} onClick={onClick} />

				case ViewType.List:
					return (
						<ProductServices_List
							isProduct={!isCart}
							activeServices={activeServices}
							allServices={services}
							relatedId={relatedId}
						/>
					)
			}
		})()}
	</section>
)
